// Código de barras EAN-13 em SVG (sem biblioteca): tabelas L/G/R oficiais e
// a paridade do 1º dígito. Usado na etiqueta da tela de Pesagem — desenha em
// "módulos" (a barra mais fina) e o SVG estica pra largura pedida em mm.
const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'];
const G = ['0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'];
const R = ['1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'];
const PARIDADE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

// 95 módulos: guarda 101 + 6 dígitos + 01010 + 6 dígitos + guarda 101
export function modulosEan13(codigo) {
  if (!/^\d{13}$/.test(codigo)) throw new Error('EAN-13 precisa de 13 dígitos.');
  const d = codigo.split('').map(Number);
  const par = PARIDADE[d[0]];
  let bits = '101';
  for (let i = 1; i <= 6; i++) bits += (par[i - 1] === 'L' ? L : G)[d[i]];
  bits += '01010';
  for (let i = 7; i <= 12; i++) bits += R[d[i]];
  return bits + '101';
}

// Barras de guarda (início, meio, fim) descem mais que as de dígito, como
// no padrão impresso; os números ficam embaixo, fora do SVG (HTML da etiqueta).
export function ean13Svg(codigo, { larguraMm = 38, alturaMm = 12 } = {}) {
  const bits = modulosEan13(codigo);
  const guarda = i => i < 3 || (i >= 45 && i < 50) || i >= 92;
  const alturaDigito = 0.88;
  let rects = '';
  for (let i = 0; i < bits.length; i++) {
    if (bits[i] !== '1') continue;
    let w = 1;
    while (i + w < bits.length && bits[i + w] === '1' && guarda(i + w) === guarda(i)) w++;
    rects += `<rect x="${i}" y="0" width="${w}" height="${guarda(i) ? 1 : alturaDigito}"/>`;
    i += w - 1;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95 1" preserveAspectRatio="none" ` +
    `width="${larguraMm}mm" height="${alturaMm}mm" shape-rendering="crispEdges" fill="#000">${rects}</svg>`;
}
